import { useRecoilValue } from "recoil";
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { attackMechanismApi } from "services/brm/attack-service";
import errorUtils from "utils/error-utils";
import {
  DetailsContainer,
  DetailsContainerParent,
} from "features/brm/components/elements/FullDetail/ElementFullDetails.styles";
import Title from "components/elements/StyledTitle";
import { projectIdState } from "atoms/atoms-admin";
import { RoutePath } from "routes/route-paths";
import AttackMechanismDetails from "../details/AttackMechanismDetails";

const listUrl = RoutePath.AttackMechanisms;

function AttackMechanismFullDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const projectId = useRecoilValue(projectIdState);
  const localProjectId = useRef(projectId);
  const [selectedElement, setSelectedElement] = useState({});
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (projectId !== localProjectId.current) {
      navigate(listUrl);
    }
  }, [projectId, navigate]);

  useEffect(() => {
    async function getData() {
      setRefresh(false);

      try {
        const res = await attackMechanismApi.getAttackMechanismByIDWithHttpInfo(id);

        if (res?.data) {
          errorUtils.checkErrorStatus(res.response.status, res.response.statusText);
          setSelectedElement(res.data);
        }
      } catch (err) {
        console.error("Error in getAttackMechanismByIDWithHttpInfo: ", err);
      }
    }
    if (refresh) {
      getData();
    }
  }, [refresh, id, setRefresh]);

  return (
    <>
      <Title id="AttackMechanismFullDetails_title">{selectedElement.name}</Title>

      <DetailsContainerParent showSummaryTable={false}>
        <DetailsContainer>
          {selectedElement.id && <AttackMechanismDetails selectedElement={selectedElement} />}
        </DetailsContainer>
      </DetailsContainerParent>
    </>
  );
}

export default AttackMechanismFullDetails;
